module.exports = __webpack_public_path__ + "img/datev.92217e15.svg";